export const handleAxiosError = (
  error,
  defaultMessage = "Načtení dat se nezdařilo. Zkuste to prosím později."
) => {
  if (error.response) {
    const status = error.response.status;
    let message;
    // Pokud je error.response.data řetězec, použijeme jej přímo
    if (typeof error.response.data === "string") {
      message = error.response.data;
    } else if (error.response.data && error.response.data.message) {
      // Pokud je objekt s vlastností 'message', použijeme tuto hodnotu
      message = error.response.data.message;
    } else {
      message = defaultMessage;
    }
    return { status, message };
  }
  // Výchozí hodnota pro síťové chyby nebo jiné typy chyb
  return { status: 500, message: defaultMessage };
};

export function handleApiError(result, fallbackMessage = "Neznámá chyba") {
  const customError = new Error(result?.message || fallbackMessage);
  customError.status = result?.status;
  return customError;
}
